import { render, staticRenderFns } from "./index.vue?vue&type=template&id=04098eba&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04098eba')) {
      api.createRecord('04098eba', component.options)
    } else {
      api.reload('04098eba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=04098eba&", function () {
      api.rerender('04098eba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/box/index.vue"
export default component.exports